/**
 * No Stock Order Interface Component
 * 
 * Interface for ordering products without stock (pre-order/backorder)
 */

import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import QuantitySelector from './QuantitySelector';

const NoStockOrderInterface = ({ 
    _productId, 
    _selectedVariation, 
    quantity, 
    onQuantityChange, 
    isMobile 
}) => {
    const [maxQuantity] = useState(99); // Default max for pre-order items
    
    return (
        <div className="fos-no-stock-section fos-fade-in">
            <div className="fos-no-stock-header">
                <div style={{
                    textAlign: 'center',
                    padding: '20px',
                    background: '#fff3cd',
                    border: '1px solid #ffeaa7',
                    borderRadius: '8px',
                    marginBottom: '20px'
                }}>
                    <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>📋</div>
                    <h4 style={{ margin: '0 0 8px', color: '#856404' }}>
                        {__('預訂商品', 'frontend-order-system')}
                    </h4>
                    <p style={{ margin: 0, fontSize: '0.9rem', color: '#856404' }}>
                        {__('此商品可以預訂', 'frontend-order-system')}
                    </p>
                </div>
            </div>
            
            <div className="fos-quantity-section">
                <QuantitySelector
                    quantity={quantity}
                    maxQuantity={maxQuantity}
                    minQuantity={0}
                    onChange={onQuantityChange}
                    title={__('設定預訂數量', 'frontend-order-system')}
                    isMobile={isMobile}
                    showQuickSelect={false}
                    showMaxLabel={false}
                    size="normal"
                />
            </div>
            
            {/* Pre-order Information */}
            <div style={{
                marginTop: '20px',
                padding: '16px',
                background: '#e7f3ff',
                border: '1px solid #0073aa',
                borderRadius: '8px'
            }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{ fontSize: '1.5rem' }}>ℹ️</span>
                    <div style={{ flex: 1 }}>
                        <h4 style={{ 
                            margin: '0 0 8px', 
                            color: '#0073aa',
                            fontSize: '1rem'
                        }}>
                            {__('預訂須知:', 'frontend-order-system')}
                        </h4>
                        <ul style={{ 
                            margin: 0, 
                            paddingLeft: '20px',
                            color: '#01579b',
                            fontSize: '0.9rem',
                            lineHeight: '1.5'
                        }}>
                            <li>{__('預訂商品將在有庫存時優先出貨', 'frontend-order-system')}</li>
                            <li>{__('出貨時間可能因供應狀況而有所差異', 'frontend-order-system')}</li>
                            <li>{__('付款後會收到預訂確認通知', 'frontend-order-system')}</li>
                            <li>{__('可隨時聯繫客服查詢預訂狀態', 'frontend-order-system')}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoStockOrderInterface;
